import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://gmrceimdhxmgrlovneui.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdtcmNlaW1kaHhtZ3Jsb3ZuZXVpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM0MDAwMzUsImV4cCI6MjA3ODk3NjAzNX0.8wrrFWrcYY_l1L9dXQYMJTXPP-8731bhwOOt2RPn2z8';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error('Supabase URL or Anon Key is missing. Please check your environment variables.');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

